/* jshint esversion: 6 */
/* jshint ignore:start */
import { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import Slider from "react-slick";
import { useNavigate } from 'react-router-dom';
import { MyContext } from '../../Context/MyProvider';
import { useTranslation } from 'react-i18next';
import Loading from '../Loading';

const LabDetails = () => {

    const { t } = useTranslation();

    const { ApiBaseUrl, ImgBaseUrl} = useContext(MyContext);

    const [loading, setLoading] = useState(true);
    const [sliderImg, setSliderImg] = useState([]);
    const [category, setCategory] = useState([]);

    const navigator = useNavigate();

    const settings = {
        arrows: false,
        dots: false,
        infinite: true,
        centerMode: true,
        speed: 1000,
        slidesToShow: 3,
        slidesToScroll: 1,
        initialSlide: 0,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [
            { breakpoint: 1200, settings: { slidesToShow: 2, slidesToScroll: 1, centerMode: true } },
            { breakpoint: 1024, settings: { slidesToShow: 2, slidesToScroll: 1, centerMode: true } },
            { breakpoint: 770, settings: { slidesToShow: 1, slidesToScroll: 1, centerMode: false } },
        ],
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        axios.get(`${ApiBaseUrl}/customer/lab_category_list`)
            .then((res) => {
                // console.log(res);
                const { ResponseCode, banner_list, category_list } = res.data;
                if (ResponseCode === 200) {
                    setLoading(false);
                    setSliderImg(banner_list);
                    setCategory(category_list);
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }, []);


    const HandleNavigate = (item) => {
        navigator("/category-details");
        sessionStorage.setItem("Docdetails", JSON.stringify({ Categoryid: item.id, title: item.name }));
    };

    useEffect(() => {
        document.body.style.overflow = "auto";
    }, [loading]);

    return (
        <div className=' pb-[50px]'>
            {false ? <Loading CustomeStyle="fixed left-0 top-0 h-[100vh] w-full flex items-center justify-center bg-white" />
                : <div className="">
                    <div className="slider-container mt-[20px]">
                        <Slider {...settings}>
                            {
                                sliderImg.map((item, index) => {
                                    return <div key={index}>
                                        <img src={ImgBaseUrl + item} className='h-[300px] max-_430_:h-[200px] object-cover w-[100%] px-1 rounded-[20px]' alt="Slider Img" />
                                    </div>
                                })
                            }
                        </Slider>
                    </div>

                    <div className="width-container">
                        <div className="ourservices mt-[20px]">
                            <h1 className='d-title'>{t("Category")}</h1>
                            <div className="flex items-center flex-wrap gap-[20px] mt-[20px]">
                                {category.map((item, index) => {
                                    return <div onClick={() => HandleNavigate(item)} key={index} className='card-box'>
                                        <img className='w-[100%] h-[100px] object-contain mx-auto rounded-[10px]' src={ImgBaseUrl + item.image} alt="" />
                                        <h1 className='font-[500] mt-[10px] text-center whitespace-nowrap overflow-hidden overflow-ellipsis'>{item.name}</h1>
                                    </div>
                                })}
                            </div>
                        </div>
                    </div>

                </div>}
        </div>
    )
}

export default LabDetails
/* jshint ignore:end */